import gql from 'graphql-tag';

export const QUERY_BRAND_SPACES_LISTING = gql`
  query BrandSpacesListing {
    stores(where: { type: "brand_space" }, sort: "sorting:asc") {
      id
      slug
      name
      brandspace_type
      image {
        alternativeText
        url
        formats
      }
      city
      country {
        name_en
        name_de
      }
    }
  }
`;
